import React, { ReactElement, useEffect } from 'react';
import { LoaderButton } from 'idsk-react-components';
import downloadIcon from '../../../../../assets/images/icon-download-blue.svg';
import Uuid from '../../../../model/Uuid';
import { useClientStatusContext } from '../../../../context/ClientStatusContext';
import fileDownloadErrorStatus from '../../../../constants/FileDownloadErrorConstant';
import { ClientStatus } from '../../../../model/ClientStatus';

interface Props {
  sprievodnyDokumentUuid?: Uuid;
  filename: string;
  downloadDokument: (dokumentUuid: Uuid, filename: string) => void;
  downloadDokumentStatus?: ClientStatus
}

export default function DownloadSprievodnyDokumentButton({
  sprievodnyDokumentUuid,
  filename,
  downloadDokument,
  downloadDokumentStatus,
}: Props): ReactElement {
  const { handleStatus } = useClientStatusContext();

  useEffect(() => {
    if (downloadDokumentStatus?.responseCode === 404) {
      handleStatus(fileDownloadErrorStatus);
    }
  }, [downloadDokumentStatus, handleStatus]);

  return sprievodnyDokumentUuid && filename ? (
    <LoaderButton
      loading={downloadDokumentStatus?.loading}
      className="sprievodny-dokument-button download-sprievodny-dokument-button"
      customIconBefore={downloadIcon}
      size="small"
      buttonStyle="link"
      onClick={() => downloadDokument(sprievodnyDokumentUuid, filename)}
      disableOutsideClickWhileLoading
    >Stiahnuť
    </LoaderButton>
  )
    : null;
}
